export default __webpack_public_path__ + "static/media/DEBOLINA SENAPATHY.605c1173.jpeg";